module.exports = __webpack_public_path__ + "img/16.d82f3d49.jpg";